// API Configuration
// In production, this should point to your deployed backend server
// In development, it uses localhost proxy

const API_URL =
  process.env.REACT_APP_AWS_DEVELOPMENT_BASE ;

export default API_URL; 
